import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconFlagWorld = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  const iconTitle = title ?? 'World'
  const iconSize = size ?? 16
  const iconColor = color ?? theme.colors.contentPrimary

  return (
    <Icon viewBox="0 0 24 24" ref={ref} title={iconTitle} size={iconSize} color={iconColor} overrides={overrides}>
      <title>{iconTitle}</title>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M3 12h18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 3c3.2 3.2 3.2 14.8 0 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 3c-3.2 3.2-3.2 14.8 0 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </Icon>
  )
}

IconFlagWorld.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconFlagWorld
